import { Info } from "@icons";
import { useInfoToggleName } from "@src/hooks/use-info-toggle-labels";
import classNames from "classnames";
import { ReactNode } from "react";

interface LabelProps {
  name: string;
  label: string | JSX.Element;
  info?: string | ReactNode;
  required?: boolean;
  error?: string;
  displayInfo: boolean;
  infoId: string;
  setDisplayInfo: React.Dispatch<React.SetStateAction<boolean>>;
  labelActions?: ReactNode;
}

export default function Label({
  name,
  label,
  info,
  required = false,
  error,
  displayInfo,
  infoId,
  setDisplayInfo,
  labelActions,
}: LabelProps) {
  const infoToggleName = useInfoToggleName(label);

  return (
    <div className="mb-0.5 flex gap-2 items-center">
      <label
        htmlFor={name}
        className={classNames(
          "font-comfortaa",
          "text-base font-light capitalize",
          {
            "text-default": !error,
            "text-danger": !!error,
          },
        )}
      >
        {label}
        <span>{required ? "*" : ""}</span>
      </label>
      {!!info && (
        <button
          type="button"
          aria-label={infoToggleName}
          aria-expanded={displayInfo}
          aria-controls={infoId}
          className="relative hit-target-min text-muted hover:text-default rounded-full focus:bg-tint focus:text-default border-0 leading-none flex items-center justify-center"
          onClick={() => setDisplayInfo((prev) => !prev)}
          data-target-gap="field-info"
        >
          <Info size={16} />
        </button>
      )}
      {labelActions && (
        <div className="flex items-center gap-3 ml-auto">{labelActions}</div>
      )}
    </div>
  );
}
